import { Box } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { type ReactElement } from "react";

interface CreditProgressBarTooltipProps {
  completedCount: number;
  requiredCount: number;
  leftPx: number;
  visible: boolean;
}

export function CreditProgressBarTooltip(props: CreditProgressBarTooltipProps): ReactElement {
  const { completedCount, requiredCount, leftPx, visible } = props;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: leftPx,
        transform: "translateX(-50%)",
        opacity: visible ? 1 : 0,
        transition: "opacity 300ms ease-out",
      }}
    >
      <Box
        sx={(theme) => ({
          background: theme.palette.text.primary,
          borderRadius: "8px",
          padding: "6px 10px",
          boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.25)",
          position: "relative",
        })}
      >
        <Text
          semibold
          variant="caption"
          color={(theme) => theme.palette.text.invertPrimary}
          sx={{ whiteSpace: "nowrap" }}
        >
          {completedCount}/{requiredCount}
        </Text>
        {/* Triangle pointer */}
        <Box
          sx={(theme) => ({
            position: "absolute",
            bottom: -6,
            left: "50%",
            transform: "translateX(-50%)",
            width: 0,
            height: 0,
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderTop: `6px solid ${theme.palette.text.primary}`,
          })}
        />
      </Box>
    </Box>
  );
}
